import React, { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  hidden?: boolean;
}

function SidePanelFooter({ children }: IProps) {
  return <footer className="novoSidePanel__footer">{children}</footer>;
}

export default SidePanelFooter;
